// extracted by mini-css-extract-plugin
module.exports = {"title":"FpxDetailNew--title--39ISV2v","label":"FpxDetailNew--label--29vrOUk","value":"FpxDetailNew--value--2KzJWCo","FpxDetail":"FpxDetailNew--FpxDetail--Lam6qMw"};